import { acpDashboardLiteStates } from './states';

export default (appModule: ng.IModule) => {
  appModule.config(acpDashboardLiteStates);
};
